import styled from "styled-components";
import { layout } from '../../../../../package.json';

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;

  section {
    div {
      margin-top: 1rem;
    }
    text-align: center;
  }
`

export const ContainerAddress = styled.div`
  width: 100%;

  display: flex;
  gap: 1rem;
  justify-content: space-around;
  align-items: center;

  margin: 3rem auto;

  @media (max-width: ${layout.tablet}) {
    flex-direction: column;
    span {
      margin-bottom: 1rem;
    }
  }
`;

export const AddressTitle = styled.span`
  color: #000000;
  font-size: 2.68rem;
  font-weight: 600;
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;
  text-align: left;
  /* Text style for "Forma de P" */
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;

  @media (max-width: ${layout.mobile}) {
      font-size:2.1rem;
  }
`;

export const AddressContent = styled.div`
  color: #000000;
  font-size: 1.75rem;
  font-weight: 400;
  font-style: normal;
  letter-spacing: normal;
  line-height: 26px;
  text-align: left;
  /* Text style for "Calçada da" */
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;

  @media (max-width: ${layout.mobile}) {
      font-size:1.5rem;
  }
`;